import { useTranslation } from "react-i18next";
import { ContentHeader, MainContentArea } from "melco-ui";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { EodSettingsList } from "../../components/settings/EODSettingsList";
import { AddIntegrationButton } from "../../components/settings/AddIntegrationButton";
import { AddIntegrationDrawer } from "../../components/settings/AddIntegrationDrawer";
import { useState } from "react";

export const EodSettings: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("settings");

  //const addEodDrawer = useGenericDrawer();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isListEmpty, setIsListEmpty] = useState(false);

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("eodsettings.title")}
          //  title={"EOD Settings"}
          breadcrumb={breadcrumb}
          extra={<AddIntegrationButton disabled={isListEmpty} setDrawerOpen={setDrawerOpen} />}
        />
      }
    >
      <EodSettingsList onDataLoaded={setIsListEmpty} />
      <AddIntegrationDrawer isDrawerOpen={isDrawerOpen}
        setDrawerOpen={setDrawerOpen} />
    </MainContentArea>
  );
};
